import {stateData, reduxState} from '../../values';

const initialState = {
    branches:       [],
    status:         stateData.state1,
    branchesEdit:   [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_branches){
        return {
            ...state,
            branches:   action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_branches){
        return {
            ...state,
            branchesEdit: action.payload
        }
    }
    return state
}
export default reducer